import React, { useState } from "react";
import "./aboutus_homepage.css";

import factory1 from "../../assets/images/AboutSection/factory_1.jpg";
import factory2 from "../../assets/images/AboutSection/factory_2.jpg";
import factory3 from "../../assets/images/AboutSection/factory_3.jpg";
import factory4 from "../../assets/images/AboutSection/factory_4.jpg";
import factory5 from "../../assets/images/AboutSection/factory_5.jpg";
import factory6 from "../../assets/images/AboutSection/factory_6.jpg";

const AboutSection = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const images = [
    { src: factory1, alt: "Factory View 1" },
    { src: factory2, alt: "Factory View 2" },
    { src: factory3, alt: "Factory View 3" },
    { src: factory4, alt: "Factory View 4" },
    { src: factory5, alt: "Factory View 5" },
    { src: factory6, alt: "Factory View 6" },
  ];

  const features = [
    "เครื่องจักร CNC คุณภาพสูง",
    "ช่างมืออาชีพที่ผ่านการอบรม",
    "วัสดุคุณภาพจากแบรนด์ชั้นนำ",
    "รับประกันคุณภาพสินค้า"
  ];

  const handleImageClick = (index) => {
    setCurrentImageIndex(index);
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <section className="about-section">
      <div className="about-container">
        {/* Title at the top center */}
        <h2 className="about-title">บริษัท 3กอ อินทีเรีย จำกัด</h2>

        {/* Main content grid */}
        <div className="about-main-content">
          <div className="about-image-slider">
            <div className="slider-main">
              <button
                className="slider-arrow slider-arrow-left"
                onClick={handlePrevImage}
                aria-label="Previous image"
              >
                ‹
              </button>

              <div className="slider-image-container">
                <img
                  src={images[currentImageIndex].src}
                  alt={images[currentImageIndex].alt}
                  className="slider-main-image"
                />
              </div>

              <button
                className="slider-arrow slider-arrow-right"
                onClick={handleNextImage}
                aria-label="Next image"
              >
                ›
              </button>
            </div>

            <div className="slider-thumbnails">
              {images.map((image, index) => (
                <div
                  key={index}
                  className={`thumbnail ${index === currentImageIndex ? 'active' : ''}`}
                  onClick={() => handleImageClick(index)}
                >
                  <img src={image.src} alt={image.alt} />
                </div>
              ))}
            </div>
          </div>

          <div className="about-content">
            <div className="about-highlight">
              <h3 className="highlight-title">
                <span className="highlight-years">ประสบการณ์กว่า 20 ปี</span> ในงานเฟอร์นิเจอร์ Fit-in
              </h3>
              <p className="highlight-description">
                เราคือโรงงานผลิตเฟอร์นิเจอร์fit-inที่มีความเชี่ยวชาญด้านชุดครัว ตู้เสื้อผ้า ผนัง TV
                และเฟอร์นิเจอร์ Built-in ทุกชนิด ด้วยเครื่องจักร CNC ที่ทันสมัย เครื่องปิดขอบอัตโนมัติ
                และเครื่องเจาะข้างที่แม่นยำ
              </p>
            </div>

            <ul className="about-features">
              {features.map((feature, index) => (
                <li key={index} className="feature-item">
                  <span className="feature-icon">✓</span>
                  <span className="feature-text">{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;